import { useRef, useMemo } from 'react';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { FaFileExport } from 'react-icons/fa';

const DataGrid = ({
    rowData,
    columnDefs,
    title,
    leftActions,
    headerActions,
    height = 400,
    pagination = false,
    paginationPageSize = 25,
    paginationPageSizeSelector = [25, 50, 100, 200, 500],
    exportFileName,
    pinnedBottomRowData,
    onRowDoubleClicked,
    ...gridProps
}) => {
    const gridRef = useRef();

    const defaultColDef = useMemo(() => ({
        sortable: true,
        filter: true,
        resizable: true,
        filterParams: {
            debounceMs: 300,
            buttons: ['reset'],
        },
    }), []);

    const onFirstDataRendered = (params) => {
        params.api.autoSizeAllColumns();
    };

    const onGridSizeChanged = (params) => {
        params.api.autoSizeAllColumns();
    };

    const handleExport = () => {
        gridRef.current.api.exportDataAsCsv({ fileName: `${exportFileName}.csv` });
    };

    const getRowStyle = pinnedBottomRowData
        ? (params) => {
            if (params.node.rowPinned) {
                return { backgroundColor: '#f8f9fa', fontWeight: 'bold', color: '#000' };
            }
            return {};
          }
        : undefined;

    const showTopBar = leftActions || headerActions || exportFileName;

    return (
        <>
            {showTopBar && (
                <div className="row mb-2">
                    <div className="col">{leftActions}</div>
                    <div className="col-auto d-flex gap-2">
                        {exportFileName && (
                            <button className="btn btn-success" onClick={handleExport}>
                                <FaFileExport /> Export
                            </button>
                        )}
                        {headerActions}
                    </div>
                </div>
            )}

            <div className="card">
                {title && (
                    <div className="card-header p-2 bg-info text-white d-flex justify-content-center">
                        <h3 className="card-title mb-0">{title}</h3>
                    </div>
                )}
                <div className="card-body">
                    <div className="ag-theme-alpine" style={{ height, width: '100%' }}>
                        <AgGridReact
                            ref={gridRef}
                            rowData={rowData}
                            columnDefs={columnDefs}
                            defaultColDef={defaultColDef}
                            domLayout="normal"
                            rowSelection="multiple"
                            animateRows={true}
                            suppressMenuHide={true}
                            enableCellTextSelection={true}
                            suppressCellFocus={true}
                            pagination={pagination}
                            paginationPageSize={paginationPageSize}
                            paginationPageSizeSelector={pagination ? paginationPageSizeSelector : undefined}
                            pinnedBottomRowData={pinnedBottomRowData}
                            getRowStyle={getRowStyle}
                            onFirstDataRendered={onFirstDataRendered}
                            onGridSizeChanged={onGridSizeChanged}
                            onRowDoubleClicked={onRowDoubleClicked}
                            {...gridProps}
                        />
                    </div>
                </div>
            </div>
            <br />
        </>
    );
};

export default DataGrid;
